import React, { useState } from "react";
import { Button, Drawer, Dropdown, Space, Typography, message } from "antd";
import { FilePdfOutlined, FileTextOutlined, MoreOutlined } from "@ant-design/icons";
import { airlineScheduleIngestApi, ingestErrorMessage } from "../../../api/v3/airlineScheduleIngestApi";

const { Paragraph } = Typography;

function sourceMenuItems({ openPdf, openOcr, loadingPdf }) {
    return [
        {
            key: "ingest-pdf",
            icon: <FilePdfOutlined />,
            label: "查看原始文件",
            disabled: loadingPdf,
            onClick: ({ domEvent }) => {
                domEvent?.stopPropagation();
                openPdf();
            },
        },
        {
            key: "ingest-ocr",
            icon: <FileTextOutlined />,
            label: "查看 OCR 原文",
            onClick: ({ domEvent }) => {
                domEvent?.stopPropagation();
                openOcr();
            },
        },
    ];
}

export default function AirlineIngestSourceButtons({
    task,
    scheduleId,
    size = "small",
    variant = "buttons",
    extraItems = [],
}) {
    const [ocrOpen, setOcrOpen] = useState(false);
    const [ocrText, setOcrText] = useState(task?.ocr_markdown || "");
    const [loadingPdf, setLoadingPdf] = useState(false);

    const resolveTask = async () => {
        if (task?.id) {
            const response = await airlineScheduleIngestApi.getTask(task.id);
            return response.data;
        }
        if (scheduleId) {
            const response = await airlineScheduleIngestApi.getBySchedule(scheduleId);
            return response.data;
        }
        throw new Error("没有关联的接入原文");
    };

    const openPdf = async () => {
        setLoadingPdf(true);
        try {
            const payload = await resolveTask();
            const url = payload.file_url;
            if (!url) {
                message.error("原始文件暂时打不开");
                return;
            }
            window.open(url, "_blank", "noopener,noreferrer");
        } catch (error) {
            message.error(ingestErrorMessage(error, "原始文件暂时打不开"));
        } finally {
            setLoadingPdf(false);
        }
    };

    const openOcr = async () => {
        try {
            const payload = await resolveTask();
            setOcrText(payload.ocr_markdown || "");
            setOcrOpen(true);
        } catch (error) {
            message.error(ingestErrorMessage(error, "OCR 原文暂时打不开"));
        }
    };

    const drawer = (
        <Drawer title="OCR 原文" open={ocrOpen} onClose={() => setOcrOpen(false)} width={720} destroyOnClose>
            <Paragraph type="secondary">认版面产出的 Markdown。改这里不会改航班建议。</Paragraph>
            <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, lineHeight: 1.5, margin: 0 }}>{ocrText || "这次接入还没有 OCR 原文。"}</pre>
        </Drawer>
    );

    if (variant === "menu") {
        const items = extraItems.length ? [...extraItems, { type: "divider" }, ...sourceMenuItems({ openPdf, openOcr, loadingPdf })] : sourceMenuItems({ openPdf, openOcr, loadingPdf });
        return (
            <>
                <Dropdown menu={{ items }} placement="bottomRight" trigger={["click"]}>
                    <Button type="link" size={size} icon={<MoreOutlined />} aria-label="更多操作" onClick={(event) => event.stopPropagation()} />
                </Dropdown>
                {drawer}
            </>
        );
    }

    return (
        <>
            <Space size="small" wrap={false}>
                <Button type="link" size={size} icon={<FilePdfOutlined />} loading={loadingPdf} onClick={openPdf}>
                    查看原始文件
                </Button>
                <Button type="link" size={size} icon={<FileTextOutlined />} onClick={openOcr}>
                    查看 OCR 原文
                </Button>
            </Space>
            {drawer}
        </>
    );
}
